(function () {
  // Theme is locked to light mode site-wide. The dark-mode toggle button is kept
  // in the DOM (markup + classes preserved) but hidden via CSS in void-theme-toggle.liquid.
  // This script:
  //   1. ensures <html data-theme="light"> even if something changed it,
  //   2. overwrites any previously stored preference (e.g. "dark") for returning visitors.
  var STORAGE_KEY = 'loid-theme';

  document.documentElement.setAttribute('data-theme', 'light');

  try {
    if (localStorage.getItem(STORAGE_KEY) !== 'light') {
      localStorage.setItem(STORAGE_KEY, 'light');
    }
  } catch (e) {
    /* localStorage unavailable (private mode, etc.) — nothing else to do */
  }
})();
